import React from 'react'

const CancelllationAndRefund = () => {
  return (
    <div className='container py-4'>
      <div className='bg-light p-4 rounded shadow-sm'>
        <h1 className='text-2xl font-bold mb-4'>
          Cancellation & Refund Policy
        </h1>

        <h2 className='text-xl font-semibold mt-4'>Cancellation Policy</h2>
        <p>
          You can cancel your order within 24 hours of purchase by emailing us
          at info@teslbird.com .
        </p>

        <h2 className='text-xl font-semibold mt-4'>Refund Policy</h2>
        <p>
          Refunds will be processed in the original payment method within 7-10
          business days after approval.
        </p>

        <ul className='list-disc ml-6 my-4'>
          <li>Products must be unused and in original packaging.</li>
          <li>
            Refunds are not applicable for digital/downloadable goods once
            accessed.
          </li>
        </ul>

        <p>For any questions, contact us at info@teslabird.com .</p>
      </div>
    </div>
  )
}

export default CancelllationAndRefund
